export default "__VITE_ASSET__57d040ce__"